/* Package JSON Import will be here */
import React, { Component } from 'react';
/* Package JSON Import will be here */

/* Styles will be here */
import './notFound.css';
/* Styles will be here */

export default class NotFound extends Component {

    render() {

        return (
            <div className="body">
                <div className="moving-zone">
                    <div className="popup">
                        <div className="popup-content">
                            <div className="popup-text">
                                404<br />
                                Page Not Found !
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NotFound.displayName = "NotFound";